<section class="top-assets">
  <h3 class="subtitle texts">CURSOS</h3>
  <article class="dropdown-center">
    <button class="btn-search-tribes" data-bs-toggle="dropdown" [class.opacity]="!hasCourses" [disabled]="!hasCourses">
      <img src="assets\icons\filter-tribe-icon.svg" alt="filter icon">
      {{option}}
      <img src="assets\icons\arrow-filter-tribe-icon.svg" alt="arrow filter icon">
    </button>
    <ul class="dropdown-menu">
      <li><a class="dropdown-item" (click)="onClick('Finalizados')">Finalizados</a></li>
      <li><a class="dropdown-item" (click)="onClick('En proceso')">En proceso</a></li>
      <li><a class="dropdown-item" (click)="onClick('Todos los cursos')">Todos los cursos</a></li>
    </ul>
  </article>
</section>
<main class="responsive-grid">
  <section class="card" [class.loading-card]="loadingCourseId === c.id" (click)="onCourseClick(c)"
    *ngFor="let c of coursesToShow, let i = index;">
    <div class="card-loader-overlay" *ngIf="loadingCourseId === c.id">
      <div class="spinner-border text-light" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <article>
      <img [src]="c.image?.url" class="card-img-top" [ngClass]="{'img-completed': isCompleted(c)}"
        [alt]="c.image?.filename || 'imágen del curso'" />
      <img src="../../../assets/icons/course-completed.svg" alt="course completed" class="course-completed"
        *ngIf="isCompleted(c)">
      <article class="card-body">
        <div class="tags">
          <span class="etiqueta" *ngFor="let cat of c.categories">{{cat.attributes.name}}</span>
        </div>
        <div class="fecha">Apertura: {{c.attributes.field_date_range.value | fechaEs:'DMY'}} &nbsp; &nbsp; Cierre:
          {{c.attributes.field_date_range.end_value | fechaEs:'DMY'}}</div>
        <h5 class="titulo">{{c.attributes.title}}</h5>
        <span class="card-percent">{{c.progress}}%&nbsp; &nbsp;<span class="card-text-percent">completado</span></span>
        <div class="progress">
          <div class="progress-bar" role="progressbar" [style.width]="c.progress + '%'" aria-valuemin="0"
            aria-valuemax="100">
          </div>
        </div>
        <div>
          <img src="assets\icons\icono_amarillo_actividad.svg" class="card-icon" alt="icono" />
          <span>
            <img src="assets\icons\icono_amarillo_libro.svg" class="card-icon" alt="icono" />
          </span>
        </div>
        <a class="btn-download-cert" *ngIf="isCompleted(c)" [href]="c.certificate?.pdfUrl" target="_blank">
          <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="#4F0B7B">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M8.50043 0.222168C8.73907 0.222168 8.93252 0.415625 8.93252 0.654266V7.1009L10.8539 5.56376C11.0403 5.41468 11.3122 5.4449 11.4613 5.63124C11.6104 5.81759 11.5802 6.08951 11.3938 6.23859L8.77036 8.33735C8.61254 8.4636 8.38831 8.4636 8.2305 8.33735L5.60704 6.23859C5.42069 6.08951 5.39048 5.81759 5.53956 5.63124C5.68864 5.4449 5.96055 5.41468 6.1469 5.56376L8.06833 7.1009V0.654266C8.06833 0.415625 8.26178 0.222168 8.50043 0.222168ZM1.15657 10.1005C1.4344 9.82269 1.81122 9.6666 2.20414 9.6666H4.88496C5.04007 9.6666 5.18329 9.74975 5.2602 9.88446C5.58645 10.4559 6.05802 10.9309 6.62707 11.2612C7.19612 11.5916 7.84242 11.7656 8.50043 11.7656C9.15843 11.7656 9.80473 11.5916 10.3738 11.2612C10.9428 10.9309 11.4144 10.4559 11.7407 9.88446C11.8176 9.74975 11.9608 9.6666 12.1159 9.6666H14.7967C15.1896 9.6666 15.5664 9.82269 15.8443 10.1005C16.1221 10.3783 16.2782 10.7552 16.2782 11.1481V14.2962C16.2782 14.6891 16.1221 15.066 15.8443 15.3438C15.5664 15.6216 15.1896 15.7777 14.7967 15.7777H2.20414C1.81122 15.7777 1.4344 15.6216 1.15657 15.3438C0.87874 15.066 0.722656 14.6891 0.722656 14.2962V11.1481C0.722656 10.7552 0.87874 10.3783 1.15657 10.1005ZM2.20414 10.5308C2.04042 10.5308 1.88341 10.5958 1.76765 10.7116C1.65189 10.8274 1.58685 10.9844 1.58685 11.1481V14.2962C1.58685 14.4599 1.65189 14.6169 1.76765 14.7327C1.88341 14.8485 2.04042 14.9135 2.20414 14.9135H14.7967C14.9604 14.9135 15.1174 14.8485 15.2332 14.7327C15.349 14.6169 15.414 14.4599 15.414 14.2962V11.1481C15.414 10.9844 15.349 10.8274 15.2332 10.7116C15.1174 10.5958 14.9604 10.5308 14.7967 10.5308H12.3586C11.9659 11.1377 11.4349 11.6445 10.8077 12.0086C10.1068 12.4155 9.31083 12.6298 8.50043 12.6298C7.69002 12.6298 6.89402 12.4155 6.19317 12.0086C5.56596 11.6445 5.03491 11.1377 4.64224 10.5308H2.20414Z" />
          </svg>
          Descargar diploma
        </a>
      </article>
    </article>
  </section>
</main>
<section>
  <h1 class="no-courses" *ngIf="!hasCourses">No tienes cursos asignados</h1>
</section>
<!-- TODO Paginación -->